export class TableLinkButtonColumnDTO {
  linkButtonColor: 'primary' | 'accent'
  linkButtonType: 'submit' | 'reset' | 'button'
  linkData: string
  linkText: string
}
